export let personaHeaderViewProfilebutton = "R780ce";
export default {personaHeaderViewProfilebutton};